<template>
  <div class="col-span-full space-y-2 tablet:col-span-6 tablet:col-start-2 tablet-landscape:col-span-8 tablet-landscape:col-start-3">
    <p v-if="loading" class="text-[15px] py-8 text-center text-gray-500">Loading…</p>
    <p v-else-if="error" class="text-[15px] py-8 text-center text-red-600">{{ error }}</p>
    <template v-else>
      <PolicyAccordionSection
        v-for="section in sections"
        :key="section.id"
        :section="section"
        :is-open="openSection === section.id"
        @toggle="$emit('toggle', section.id)"
      />
    </template>
  </div>
</template>

<script setup>
import PolicyAccordionSection from './PolicyAccordionSection.vue'

defineProps({
  sections: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  },
  error: {
    type: String,
    default: null
  },
  openSection: {
    type: [String, null],
    default: null
  }
})

defineEmits(['toggle'])
</script>
